import React from 'react';
import DashboardContext from 'contexts/DashboardContext';
import UserContext from 'contexts/UserContext';
import get from 'lodash/get';
import Paper from '@material-ui/core/Paper';
import { Thread } from 'amplify-model-react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from 'react-select';
import BubbleComment from './BubbleComment';

const useStyles = makeStyles({
  root: {
    padding: 10
  },
  shopToggle: {
    float: 'right'
  },
  sendTo: {
    minWidth: 300
  },
  toSelect: {
    width: 250,
    minWidth: 200
  },
  actionHeader: {
    marginTop: 10,
    '& div': {
      zIndex: 2
    }
  },
  thread: {
    '& textarea': {
      zIndex: 0
    }
  }
});

export const THREAD_SUBJ_PRE = 'thread::';

function getMemberLabel(myStaff) {
  return '👨‍⚕️ ' + myStaff.firstName + ' ' + myStaff.lastName;
}

export default function ShopTalk({ sendTo }) {
  const [state, setState] = React.useState({
    showShopMessages: true,
    selectedSubject: null
  });

  const classes = useStyles();
  const { state: dashboardState } = React.useContext(DashboardContext);
  const store = get(dashboardState, 'context.currentStore');
  const { currentUser } = React.useContext(UserContext);
  const memberId = currentUser.username;
  const roleGroup = get(currentUser, 'memberInfo.role.group');
  // console.log('>>CoachCornerPage/ShopTalk::', 'currentUser', currentUser, roleGroup); //TRACE
  const subjects = React.useMemo(() => {
    const subjs = [];
    if (state.selectedSubject) {
      subjs.push(state.selectedSubject.value);
    }
    if (state.showShopMessages && !subjs.includes(THREAD_SUBJ_PRE + store)) {
      subjs.push(THREAD_SUBJ_PRE + store);
    }
    return subjs;
  }, [state.showShopMessages, state.selectedSubject, store]);

  const isAllowedToAnnounce = ['Admins', 'Management'].includes(roleGroup);

  const options = React.useMemo(() => {
    const opts = [];
    if (isAllowedToAnnounce)
      opts.push({
        label: '🔊 Store Announcement',
        key: 'STORE:::' + store,
        value: THREAD_SUBJ_PRE + store
      });

    const myMngr = get(currentUser, 'memberInfo.manager');
    if (myMngr) {
      opts.push({
        label: getMemberLabel(myMngr) + ' (manager)',
        key: 'MEMBER:::' + myMngr.id,
        value: THREAD_SUBJ_PRE + store + ':' + myMngr.id + ':' + memberId
      });
    }
    const myMembers = get(currentUser, 'memberInfo.members.items', []);
    myMembers.forEach(myStaff => {
      if (!myStaff) return;
      opts.push({
        label: getMemberLabel(myStaff),
        key: 'MEMBER:::' + myStaff.id,
        value: THREAD_SUBJ_PRE + store + ':' + memberId + ':' + myStaff.id
      });
    });
    return opts;
  }, [isAllowedToAnnounce, currentUser, store, memberId]);

  console.log('>>CoachCornerPage/ShopTalk::', 'options', subjects); //TRACE

  const handleRenderComment = React.useCallback(comment => {
    return <BubbleComment comment={comment} />;
  }, []);

  const handleSelectTo = React.useCallback(o => {
    setState(oldState => ({ ...oldState, selectedSubject: o }));
  }, []);

  React.useEffect(() => {
    const s = options.find(o => o.key === sendTo);
    if (!s) return;
    handleSelectTo(s);
    console.log('>>CoachCornerPage/ShopTalk::', 's', s); //TRACE
  }, [handleSelectTo, options, sendTo]);

  return (
    <Paper className={classes.root}>
      <Typography variant="subtitle1">💬 Shop Talk</Typography>
      <div className={classes.actionHeader}>
        <FormControlLabel
          className={classes.shopToggle}
          control={
            <Checkbox
              checked={state.showShopMessages}
              onChange={() =>
                setState(oldState => ({
                  ...oldState,
                  showShopMessages: !state.showShopMessages
                }))
              }
              color="primary"
            />
          }
          label="Show Shop Announcements"
        />
        <div className={classes.sendTo}>
          <label>Send To:</label>
          <Select
            className={classes.toSelect}
            options={options}
            value={state.selectedSubject}
            onChange={handleSelectTo}
          />
        </div>
      </div>
      <div className={classes.thread}>
        <Thread
          key={JSON.stringify(subjects || {})}
          subjects={subjects}
          currentUserId={memberId}
          inputProps={{
            label: 'I am going to concentrate on...'
          }}
          renderComment={handleRenderComment}
        />
      </div>
    </Paper>
  );
}
